"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _state = require("@seedlang/state");
var _lodash = require("lodash");
var _mobx = require("mobx");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _constants = require("@seedlang/constants");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var GrammarWrapper = function GrammarWrapper(Component) {
  var _class, _class2, _descriptor;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "loadedTree", _descriptor, _this);
      (0, _mobx.autorun)(function () {
        if (_state.AppUI.userIsLoaded && !_this.loadedTree) {
          _state.TreeUI.loadTree(_constants.Constants.GRAMMAR_TREE_BY_LANGUAGE[_state.AppUI.targetLanguageId], _this.afterLoadTree);
          _this.loadedTree = true;
        }
      });
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "afterLoadTree",
      value: function afterLoadTree(resp) {
        if (_state.AppUI.userTreeNodeStore.hasIndexData) {
          var treeNodeIds = (0, _lodash.flattenDepth)(resp.treeModules.map(function (item) {
            return item.treeRows.map(function (item2) {
              return item2.treeNodes;
            });
          }), 2).map(function (item) {
            return item.id;
          });
          if (treeNodeIds.length !== treeNodeIds.length) {
            _state.TreeUI.userTreeNodeStore.loadGrammarIndex({
              ids: {
                language_id: _state.AppUI.targetLanguageId
              }
            });
          }
        } else {
          _state.TreeUI.userTreeNodeStore.loadGrammarIndex({
            ids: {
              language_id: _state.AppUI.targetLanguageId
            }
          });
        }
      }
    }, {
      key: "currentTreeNodeId",
      get: function get() {
        var _TreeUI$grammarTree, _TreeUI$grammarTree2;
        return this.props.params.grammarNodeId || _state.AppUI.targetLanguage.lastVisitedGrammarNodeId || ((_TreeUI$grammarTree = _state.TreeUI.grammarTree) === null || _TreeUI$grammarTree === void 0 ? void 0 : _TreeUI$grammarTree.treeNodes) && ((_TreeUI$grammarTree2 = _state.TreeUI.grammarTree) === null || _TreeUI$grammarTree2 === void 0 ? void 0 : _TreeUI$grammarTree2.treeNodes[0].id);
      }
    }, {
      key: "selectTreeNode",
      value: function selectTreeNode(treeNode) {
        if (this.currentTreeNodeId !== treeNode.id) {
          _state.AppUI.routeStore.routeToNamed('grammar.show.slug', {
            grammarNodeId: treeNode.id,
            slug: treeNode.name
          });
          _state.AppUI.targetLanguageStore.update({
            data: {
              lastVisitedGrammarNodeId: treeNode.id
            },
            ids: {
              languageId: _state.AppUI.targetLanguageId,
              userId: _state.AppUI.user.id
            }
          }, _lodash.noop);
          if ((0, _utils.isPresent)(_state.AppUI.targetLanguage)) {
            _state.AppUI.targetLanguage.set('lastVisitedGrammarNodeId', treeNode.id); // new
          }
        }
      }
    }, {
      key: "currentTreeNode",
      get: function get() {
        var _TreeUI$grammarTree3,
          _this2 = this;
        return (_TreeUI$grammarTree3 = _state.TreeUI.grammarTree) === null || _TreeUI$grammarTree3 === void 0 || (_TreeUI$grammarTree3 = _TreeUI$grammarTree3.treeNodes) === null || _TreeUI$grammarTree3 === void 0 ? void 0 : _TreeUI$grammarTree3.find(function (item) {
          return item.id === _this2.currentTreeNodeId;
        });
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          currentTreeNode: this.currentTreeNode,
          currentTreeNodeId: this.currentTreeNodeId,
          onSelectNode: this.selectTreeNode,
          tree: _state.TreeUI.grammarTree
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "loadedTree", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "afterLoadTree", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterLoadTree"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentTreeNodeId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "currentTreeNodeId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectTreeNode", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "selectTreeNode"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentTreeNode", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "currentTreeNode"), _class2.prototype), _class2)) || _class;
};
GrammarWrapper.displayName = 'GrammarWrapper';
var _default = exports["default"] = GrammarWrapper;